import { defineMessages } from 'react-intl';

export default defineMessages({
  courtManagerJudgementValidate: {
    id: 'court_manager_legal_proceedings_page.procedure_decision.validate',
  },
  courtManagerJudgementRefuse: {
    id: 'court_manager_legal_proceedings_page.procedure_decision.refuse',
  },
  managerDecision: {
    id: 'manager.decision.title',
  },
  validate: {
    id: 'legal_proceeding_page.validation_buttons.validate',
  },
  validationMessage: { id: 'appeal_add_update.success' },
  lawyerFirmReferenceUpdateMessage: {
    id: 'legal_proceeding_page.check_firm_reference_info',
  },
  lawyerFirmReferenceDialogLabel: {
    id: 'legal_proceeding_page.update_firm_reference_dialog_label',
  },
  saveButton: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.recap.title.judgementAdd.saveButton',
  },
  creatorTitle: {
    id: 'legal_proceeding_page.update_firm_reference_lawyer_name',
  },
  creatorTitleMultiple: {
    id: 'legal_proceeding_page.judgement_add_multiple_created_by',
  },
  generateFeeNote: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.recap.title.judgementAdd.generateFeeNote',
  },
  courtManagerJudgementUpdate: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.recap.update',
  },
});
